// extracted by mini-css-extract-plugin
export default {"container":"MisAccesos_container__NtJTx","container_body":"MisAccesos_container_body__sL2C5","emptyState":"MisAccesos_emptyState__jhWfi"};